import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routers from './Routes';
import { AuthProvider } from './Context/AuthContext';
import { ConfigProvider } from './Context/ConfigContext';

function App() {
  return (
    <ConfigProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routers />
          <ToastContainer />
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;

